import React from 'react';

const DocumentList = ({ 
  documents, 
  loading, 
  error, 
  selectedDocument, 
  onDocumentSelect, 
  onDocumentDelete 
}) => {
  const formatFileSize = (bytes) => {
    if (!bytes) return 'N/A';
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const handleDelete = (documentId, documentName, e) => {
    e.stopPropagation(); // Prevent document selection when clicking delete
    
    if (window.confirm(`Are you sure you want to delete "${documentName}"?`)) {
      onDocumentDelete(documentId);
    }
  };

  const getDocumentIcon = (doc) => {
    // Check if document is a text document based on metadata
    if (doc.metadata?.document_type === 'text') {
      return (
        <svg className="doc-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <line x1="10" y1="9" x2="8" y2="9"></line>
        </svg>
      );
    }
    return (
      <svg className="doc-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
      </svg>
    );
  };

  const getDocumentType = (doc) => {
    if (doc.metadata?.document_type === 'text') {
      return 'Text';
    }
    return 'PDF';
  };

  if (loading) {
    return (
      <div className="document-list">
        <h3>Documents</h3>
        <div className="loading">Loading documents...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="document-list">
        <h3>Documents</h3>
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="document-list">
      <h3>Documents ({documents.length})</h3>
      
      {documents.length === 0 ? (
        <div className="empty-state">
          No documents uploaded yet.<br/>
          Upload a PDF to get started.
        </div>
      ) : (
        <div className="documents-container">
          {documents.map((doc) => (
            <div
              key={doc.document_id}
              className={`document-item ${selectedDocument === doc.document_id ? 'selected' : ''}`}
              onClick={() => onDocumentSelect(doc)}
            >
              <div className="document-info">
                <div className="document-name" title={doc.document_name}>
                  {getDocumentIcon(doc)} {doc.document_name}
                </div>
                <div className="document-meta">
                  <div>
                    {getDocumentType(doc)} • {doc.chunk_count} chunks • {formatFileSize(doc.file_size_bytes)}
                  </div>
                  <div>
                    Uploaded: {formatDate(doc.created_at)}
                  </div>
                  {doc.processing_job_id && (
                    <div style={{ fontSize: '0.7rem', color: '#999' }}>
                      Job: {doc.processing_job_id.slice(0, 8)}...
                    </div>
                  )}
                </div>
              </div>
              
              <div className="document-actions">
                <button
                  className="delete-btn"
                  onClick={(e) => handleDelete(doc.document_id, doc.document_name, e)}
                  title="Delete document"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DocumentList;